import {
    Button, Paper, Grid, TextField, FormControl, InputLabel, Select, Chip, Tabs, Tab, Card, CardHeader, CardContent, ExpansionPanel,
    ExpansionPanelSummary, ExpansionPanelDetails, Typography, Divider, Dialog, DialogTitle, DialogContent, DialogActions,
    List, ListItem, ListItemIcon, IconButton, ListItemText, Fab
} from "@material-ui/core";
import * as React from "react";
import { observable, toJS, action } from "mobx";
import { createStyles, withStyles, WithStyles } from "@material-ui/core/styles";
import { history } from "src/history.js";
import { authStore } from "src/modules/auth";
import { observer } from 'mobx-react';
import { withRouter } from 'react-router';
import { AdminToolBar } from '../admin/components';
import { supportStore } from '.';
import * as moment from 'moment';
import { ExpandMore } from "@material-ui/icons";
import RichTextEditor from 'react-rte';
import Dropzone from 'react-dropzone';
import { assetStore } from '../asset';
import { Clear } from "@material-ui/icons";
import { AttachFile, Forum, Add } from "@material-ui/icons";
import { SupportForm } from '.';

type GroupName =
    | "INLINE_STYLE_BUTTONS"
    | "BLOCK_TYPE_BUTTONS"
    | "LINK_BUTTONS"
    | "BLOCK_TYPE_DROPDOWN"
    | "HISTORY_BUTTONS"
    | "IMAGE_BUTTON";

const displayTest: GroupName[] = ['INLINE_STYLE_BUTTONS', 'BLOCK_TYPE_BUTTONS', 'LINK_BUTTONS', 'BLOCK_TYPE_DROPDOWN', 'HISTORY_BUTTONS', 'IMAGE_BUTTON']


const styles = createStyles({
    root: {
        width: "100%",
        height: "100%",
        margin: "0 auto",
        // padding: "1.5rem",
        display: "flex",
        flexDirection: "column",
    },
    rowContainer: {
        marginTop: '10px'
        // width: "100%",
        // display: "flex",
        // alignContent: "center",
        // margin: "0 auto",  
        // padding: "3rem",
        // overflowX: 'hidden'
    },
    noteButton: {
        // float: 'right',
        marginTop: '5px',
        marginBottom: '5px'
    }
});

@observer
class SupportTicketList extends React.Component<any> {
    public state = { noteModal: { open: false, ticket_id: 0 }, ticketModal: { open: false } }

    public toolbarConfig = {
        // Optionally specify the groups to display (displayed in the order listed).
        // display: ['INLINE_STYLE_BUTTONS', 'BLOCK_TYPE_BUTTONS', 'LINK_BUTTONS', 'BLOCK_TYPE_DROPDOWN', 'HISTORY_BUTTONS', 'IMAGE_BUTTON'],
        display: displayTest,
        INLINE_STYLE_BUTTONS: [
            { label: 'Bold', style: 'BOLD', className: 'custom-css-class' },
            { label: 'Italic', style: 'ITALIC' },
            { label: 'Underline', style: 'UNDERLINE' }
        ],
        BLOCK_TYPE_DROPDOWN: [
            { label: 'Normal', style: 'unstyled' },
            { label: 'Heading Large', style: 'header-one' },
            { label: 'Heading Medium', style: 'header-two' },
            { label: 'Heading Small', style: 'header-three' }
        ],
        BLOCK_TYPE_BUTTONS: [
            { label: 'UL', style: 'unordered-list-item' },
            { label: 'OL', style: 'ordered-list-item' },
        ],
    };

    constructor(props: any) {
        super(props);
    }

    public handleNoteContentChange = (e: any) => {
        supportStore.newNote.content = e;
    };

    public closeNoteModal = () => {
        this.setState({ noteModal: { open: false, ticket_id: 0 } })
        supportStore.newNote = { content: RichTextEditor.createEmptyValue(), attachments: [] }
    };

    public closeTicketModal = () => {
        this.setState({ ticketModal: { open: false } })
        supportStore.newTicket = { description: RichTextEditor.createEmptyValue(), attachments: [], subject: '' }
    };

    public handleDrop = async (files: any) => {
        const data = new FormData();
        data.append('auth_id', authStore.currentUser.auth_id.toString())
        data.append('relation', 'freshdesk_note')
        data.append('relation_id', '0')
        files.forEach((file: any) => {
            data.append('assetFile', file)
        });
        const new_ids = await assetStore.insertAssetWithRelation(data);
        supportStore.newNote.attachments = supportStore.newNote.attachments.concat(new_ids);
    };

    public handleNoteSubmit = async (ticket_id: number) => {
        supportStore.submitNote(ticket_id);
        this.closeNoteModal()
    };

    public handleRemoveAsset = (asset_id: number) => {
        supportStore.newNote.attachments = supportStore.newNote.attachments.filter((item: any) => item.asset_id !== asset_id);
    };

    public render() {
        const { classes } = this.props;

        const ticketModal = () => {
            return (
                // tslint:disable-next-line: jsx-no-lambda
                <Dialog open={this.state.ticketModal.open} onBackdropClick={() => this.closeTicketModal()} fullWidth={true} maxWidth={'lg'}>
                    <DialogTitle>New Ticket</DialogTitle>
                    <SupportForm closeFunction={this.closeTicketModal} />
                </Dialog>
            )
        }

        const noteModal = () => {
            return (
                // tslint:disable-next-line: jsx-no-lambda
                <Dialog open={this.state.noteModal.open} onBackdropClick={() => this.closeNoteModal()}>
                    <DialogTitle>New Note</DialogTitle>
                    <DialogContent>
                        <Paper>
                            <RichTextEditor
                                toolbarConfig={this.toolbarConfig}
                                value={supportStore.newNote.content}
                                // tslint:disable-next-line: jsx-no-lambda
                                onChange={(e) => this.handleNoteContentChange(e)}
                                className='h-full'
                                editorStyle={{ 'minHeight': 120 }}
                            />

                            <Grid container={true} spacing={8}>
                                <Grid item={true} xs={6}>
                                    {/* tslint:disable-next-line: jsx-no-lambda */}
                                    <Dropzone onDrop={acceptedFiles => this.handleDrop(acceptedFiles)}>
                                        {({ getRootProps, getInputProps }) => (
                                            <section>
                                                <div {...getRootProps()} style={{
                                                    border: '3px dashed white', padding: '20px', margin: '10px', maxWidth: '200px',
                                                    background: 'radial-gradient(circle, rgba(199,45,45,0.7091211484593838) 0%, rgba(184,109,88,1) 100%)'
                                                }}>
                                                    <input {...getInputProps()} />
                                                    <p>Drop Attachments Here</p>
                                                </div>
                                            </section>
                                        )}
                                    </Dropzone>
                                </Grid>
                                <Grid item={true} xs={6}>
                                    <List>
                                        {supportStore.newNote.attachments.map((attachment: any) => {
                                            return (
                                                <ListItem key={attachment.attachment_id}>
                                                    <ListItemIcon>
                                                        <IconButton
                                                            // tslint:disable-next-line: jsx-no-lambda
                                                            onClick={() => this.handleRemoveAsset(attachment.asset_id)}
                                                        >
                                                            <Clear />
                                                        </IconButton>
                                                    </ListItemIcon>
                                                    <ListItemText primary={attachment.AssetName} />
                                                </ListItem>
                                            )
                                        })}
                                    </List>
                                </Grid>
                            </Grid>

                        </Paper>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            classes={{ root: classes.submitButton }}
                            // tslint:disable-next-line: jsx-no-lambda
                            onClick={() => this.handleNoteSubmit(this.state.noteModal.ticket_id)}
                            variant='contained'
                        >
                            Add Note
                        </Button>
                    </DialogActions>
                </Dialog>
            )
        }

        return (
            <div style={{ width: '97%' }}>
                {noteModal()}
                {ticketModal()}
                <Grid
                    container={true}
                    // direction="row"
                    classes={{ container: classes.rowContainer }}
                    spacing={8}
                >
                    <Grid item={true} xs={1} />
                    <Grid item={true} xs={10}>
                        <Grid container={true} spacing={8} style={{ paddingLeft: '4%', paddingRight: '4%' }}>

                            {this.props.ticketList.map((ticket: any) => {
                                return (
                                    <React.Fragment key={ticket.id}>
                                        {/* <Grid item={true} xs={12} key={ticket.id} style={{ 'marginLeft': '10%', 'marginRight': '10%', fontFamily: '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif' }}> */}
                                        <Grid item={true} xs={12} style={{ fontFamily: '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif' }}>
                                            <ExpansionPanel>
                                                <ExpansionPanelSummary expandIcon={<ExpandMore />} style={{ border: '1px solid #bbdcfe', backgroundImage: 'linear-gradient(#e5f2fd,#e5f2fd)', borderColor: '#bbdcfe', borderTopLeftRadius: '4px', borderTopRightRadius: '4px' }}>
                                                    <div style={{ width: '100%' }}>
                                                        <div style={{ float: 'left' }}>
                                                            <Typography variant={'h5'}>{ticket.subject}</Typography>
                                                            <Typography variant={'subtitle1'}>Created: {moment(ticket.created_at).format('ddd, D MMM YYYY')}</Typography>
                                                        </div>
                                                        <div style={{ float: 'right' }}>
                                                            <Typography variant={'subtitle1'}>Status: {ticket.statusText}</Typography>
                                                            <Typography variant={'subtitle1'}>Due By: {moment(ticket.due_by).format('ddd, D MMM YYYY')}</Typography>
                                                        </div>
                                                    </div>

                                                </ExpansionPanelSummary>
                                                <ExpansionPanelDetails style={{ display: 'block', backgroundImage: 'linear-gradient(#e5f2fd,#e5f2fd)', borderLeft: '1px solid #bbdcfe', borderRight: '1px solid #bbdcfe', borderBottom: '1px solid #bbdcfe' }}>
                                                    <div dangerouslySetInnerHTML={{ __html: ticket.description }} style={{ borderBottom: '1px solid #bbdcfe', marginBottom: '10px' }} />
                                                    {ticket.attachments.map((a: any) => {
                                                        return (
                                                            <a style={{ textDecoration: 'none', color: '#183247' }} key={a.id} target="_blank" href={a.attachment_url}>
                                                                <div key={a.id} style={{ backgroundColor: 'white', padding: '8px 12px', cursor: 'pointer', margin: '0 8px 8px 0', display: 'inline-block', minWidth: '150px', border: '1px solid transparent', borderRadius: '4px' }}>
                                                                    <AttachFile />{a.name}
                                                                </div>
                                                            </a>
                                                        )
                                                    })}

                                                </ExpansionPanelDetails>
                                                {ticket.conversations.length > 0 ?
                                                    <React.Fragment>
                                                        {ticket.conversations.map((conversation: any) => {
                                                            return (
                                                                <div key={conversation.id} style={{ backgroundColor: '#F8F8F8', padding: '10px', border: '1px solid rgba(0, 0, 0, .125)', marginTop: '5px' }}>
                                                                    <div style={{ padding: '10px', borderBottom: '1px solid #ebeff3' }}><span style={{ fontWeight: 500 }}>{conversation.incoming === true ? 'You' : 'TheMedPortal'}</span> -  {moment(conversation.created_at).format('ddd, D MMM YYYY h:mm A')}</div>
                                                                    <div style={{ padding: '10px' }} key={conversation.id} dangerouslySetInnerHTML={{ __html: conversation.body }} />
                                                                    {conversation.attachments.map((a: any, i: number) => {
                                                                        return (
                                                                            <a style={{ textDecoration: 'none', color: '#183247' }} key={a.id} target="_blank" href={a.attachment_url}>
                                                                                <div key={a.id} style={{ backgroundColor: 'white', padding: '8px 12px', cursor: 'pointer', margin: '0 8px 8px 0', display: 'inline-block', minWidth: '150px', border: '1px solid transparent', borderRadius: '4px' }}>
                                                                                    <AttachFile />{a.name}
                                                                                </div>
                                                                            </a>
                                                                        )
                                                                    })}
                                                                </div>
                                                            )
                                                        })}
                                                    </React.Fragment>
                                                    : null}
                                                {this.props.closed ? null :
                                                    <div style={{ backgroundColor: '#F8F8F8', padding: '10px', border: '1px solid rgba(0, 0, 0, .125)', marginTop: '5px' }}>
                                                        <Button
                                                            // tslint:disable-next-line: jsx-no-lambda
                                                            onClick={() => this.setState({ noteModal: { open: true, ticket_id: ticket.id } })}
                                                        >
                                                            <Forum style={{ marginRight: '5px' }} />
                                                            Add Note
                                                    </Button>
                                                    </div>
                                                }
                                            </ExpansionPanel>
                                        </Grid>
                                    </React.Fragment>

                                )
                            })}

                        </Grid>
                    </Grid>
                    <Grid item={true} xs={1}>
                        {this.props.closed ? null :
                            <Fab
                                // tslint:disable-next-line: jsx-no-lambda
                                onClick={() => this.setState({ ticketModal: { open: true } })}
                            >
                                <Add />
                            </Fab>
                        }
                    </Grid>

                </Grid >
            </div >
        )
    }
}

export default withStyles(styles, { withTheme: true })(
    withRouter(SupportTicketList)
);


// WEBPACK FOOTER //
// ./src/modules/support/SupportTicketList.tsx